import { Action } from 'redux';
import { DraftState } from '@/types';

export enum DraftActionTypes {
  SET_DRAFT = '@draft/set',
}

export interface SetDraftAction extends Action {
  type: DraftActionTypes.SET_DRAFT;
  draft: DraftState;
}

export type DraftActions = SetDraftAction;
